import React from 'react';
import { useBrandConfig } from '../context/BrandConfigContext';

/**
 * Renders the brand icon from SVG path data provided by the server config.
 * Falls back to showing the iconText character if no SVG paths are configured.
 */
export function BrandIcon({ size = 20 }: { size?: number }) {
  const { iconSvgPaths, iconViewBox, iconFillRule, iconText, fonts } = useBrandConfig();

  if (iconSvgPaths.length === 0) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          fontFamily: fonts.brandFont,
          fontSize: `${Math.round(size * 0.7)}px`,
          fontWeight: fonts.brandFontWeight,
          lineHeight: 1,
        }}
      >
        {iconText}
      </span>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={iconViewBox}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {iconSvgPaths.map((d, i) => (
        <path key={i} d={d} fillRule={iconFillRule ?? 'nonzero'} />
      ))}
    </svg>
  );
}
